import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { theme } from '../../../../theme/theme'
import { BodySmall, BodyTiny, Title6 } from '../../../styles/Typography'
import { ChartContainer } from '../../../charts/shared'
import { Testimonial } from '../../../../api/ester-b2b-api/private/analytics/types'

type Props = {
  testimonials: Testimonial[]
}

export const TestimonialsSection = ({ testimonials }: Props) => {
  const { t } = useTranslation()

  if (testimonials.length === 0) return null

  return (
    <Section>
      <Title as="h3">{t('admin.statistics.testimonialsTitle')}</Title>
      <Intro>{t('admin.statistics.testimonialsIntro')}</Intro>
      <Quotes $columns={Math.min(testimonials.length, 3)}>
        {testimonials.map((testimonial) => (
          <Quote key={testimonial.id}>
            <QuoteText>{testimonial.feedback}</QuoteText>
          </Quote>
        ))}
      </Quotes>
      <Footnote>{t('admin.statistics.testimonialsFootnote')}</Footnote>
    </Section>
  )
}

const Section = styled(ChartContainer)`
  margin-bottom: ${theme.spacing.xxlarge}px;

  @media print {
    margin-bottom: 0;
  }
`

const Title = styled(Title6)`
  color: ${theme.color.plum};
`

const Intro = styled(BodySmall)`
  color: ${theme.color.greyBlue};
  margin-bottom: ${theme.spacing.mediumLarge}px;
`

const Quotes = styled.div<{ $columns: number }>`
  display: grid;
  grid-template-columns: repeat(${({ $columns }) => $columns}, 1fr);
  gap: ${theme.spacing.medium}px;

  @media screen and (max-width: ${theme.breakpoint.medium}px) {
    grid-template-columns: 1fr;
  }
`

const Quote = styled.div`
  display: flex;
  align-items: center;
  border-left: 2px solid ${theme.color.mauve};
  padding-left: ${theme.spacing.medium}px;
`

const QuoteText = styled(BodySmall)`
  font-family: ${theme.font.heading};
  font-style: italic;
  color: ${theme.color.plum};
`

const Footnote = styled(BodyTiny)`
  color: ${theme.color.grey5};
  margin-top: ${theme.spacing.mediumLarge}px;
`
